import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { compose, setDisplayName } from 'react-recompose';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';

const SubscriptionActiveComponent = ({ anyOf, heAccount, children }) =>
  heAccount && [].concat(anyOf).some((sub) => includes(heAccount.activeSubscriptions, sub)) && children;
const SubscriptionActive = compose(
  setDisplayName('SubscriptionActive'),
  withHEAccountSubscriptions,
)(SubscriptionActiveComponent);
SubscriptionActive.propTypes = {
  children: PropTypes.node,
  anyOf: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};
export default SubscriptionActive;
